import React from 'react';
import { ArrowRight } from 'lucide-react';
import { stats } from '../../utils/data';

const Hero: React.FC = () => {
  return (
    <section id="home" className="bg-gradient-to-br from-white to-primary-50 py-20 lg:py-32">
      <div className="container-custom">
        {/* Texto Centralizado */}
        <div className="text-center max-w-4xl mx-auto mb-16">
          <div className="space-y-6">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-primary-100 text-primary-700 text-sm font-medium">
              🏆 Top 1000 Prêmio Sebrae Startups
            </div>
            <h1 className="text-4xl lg:text-6xl xl:text-7xl font-bold text-gray-900 leading-tight">
              Transforme seus dados em{' '}
              <span className="text-primary-600">decisões estratégicas</span>
            </h1>
            <p className="text-xl lg:text-2xl text-gray-600 max-w-3xl mx-auto">
              Plataforma completa de Business Intelligence e Analytics para impulsionar o crescimento da sua empresa através de insights baseados em dados.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
            <a 
              href="https://app.bdanalytics.com.br/auth/register" 
              className="btn-primary flex items-center justify-center group"
              target="_blank"
              rel="noopener noreferrer"
            >
              Começar a usar - 14 dias grátis
              <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          {/* Estatísticas Impressionantes */}
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-2xl lg:text-3xl font-bold text-primary-600 mb-1">
                  {stat.number}
                </div>
                <div className="text-sm lg:text-base font-medium text-gray-700 mb-1">
                  {stat.label}
                </div>
                <div className="text-xs text-gray-500">
                  {stat.description}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Imagem do Dashboard */}
        <div className="flex justify-center">
          <div className="relative max-w-5xl w-full">
            <div className="relative z-10 bg-white rounded-2xl shadow-2xl overflow-hidden">
              <img 
                src="/images/print_screen.png" 
                alt="Dashboard BD Analytics - Business Intelligence e Analytics" 
                className="w-full h-auto object-cover"
              />
            </div>
            
            {/* Background elements */}
            <div className="absolute -top-4 -right-4 w-72 h-72 bg-primary-200 rounded-full opacity-20"></div>
            <div className="absolute -bottom-4 -left-4 w-48 h-48 bg-primary-300 rounded-full opacity-20"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 